export default __webpack_public_path__ + "static/media/ecoso-footer.5ef88134.png";